import {Epic} from 'redux-observable'
import {concat, from, of} from 'rxjs'
import {
  catchError,
  filter,
  ignoreElements,
  mergeMap,
  switchMap,
  tap,
} from 'rxjs/operators'

import {RootState, AppActions} from 'app/rootReducer'
import Toast from 'components/Basic/Toast'
import {Policy} from 'interfaces'
import {PoliciesService} from 'services/api'
import {policiesActions} from '../policiesSlice'

const getCloudAppEpic: Epic<AppActions, AppActions, RootState> = action$ =>
  action$.pipe(
    filter(policiesActions.getCloudApp.match),
    switchMap(({payload}) =>
      from(PoliciesService.getCloudApp(payload)).pipe(
        mergeMap(({data}) => [policiesActions.getCloudAppSuccess(data)]),
        catchError((message: string) =>
          concat(of(policiesActions.getCloudAppFailure(message))),
        ),
      ),
    ),
  )

const getCloudAppFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(policiesActions.getCloudAppFailure.match),
    tap(({payload: message}) => {
      Toast({message, type: 'error'})
    }),
    ignoreElements(),
  )

const getBaseCloudAppEpic: Epic<AppActions, AppActions, RootState> = action$ =>
  action$.pipe(
    filter(policiesActions.getBasePolicyCloudApp.match),
    switchMap(() =>
      from(PoliciesService.getCloudApp({policyName: Policy.BasePolicy})).pipe(
        mergeMap(({data}) => [
          policiesActions.getBasePolicyCloudAppSuccess(data),
        ]),
        catchError((message: string) =>
          concat(of(policiesActions.getBasePolicyCloudAppFailure(message))),
        ),
      ),
    ),
  )

const getBaseCloudAppFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(policiesActions.getBasePolicyCloudAppFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

const updateCloudAppEpic: Epic<AppActions, AppActions, RootState> = action$ =>
  action$.pipe(
    filter(policiesActions.updateCloudApp.match),
    switchMap(({payload}) =>
      from(PoliciesService.updateCloudApp(payload)).pipe(
        mergeMap(() => [
          policiesActions.updateCloudAppSuccess(
            'CloudApp Updated Successfully',
          ),
        ]),
        catchError((message: string) =>
          concat(of(policiesActions.updateCloudAppFailure(message))),
        ),
      ),
    ),
  )

const updateCloudAppFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(policiesActions.updateCloudAppFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

const updateCloudAppSuccessEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(policiesActions.updateCloudAppSuccess.match),
    tap(({payload: message}) => Toast({message, type: 'success'})),
    ignoreElements(),
  )

export const cloudAppEpics = [
  getCloudAppEpic,
  getCloudAppFailureEpic,
  updateCloudAppEpic,
  updateCloudAppFailureEpic,
  updateCloudAppSuccessEpic,
  getBaseCloudAppEpic,
  getBaseCloudAppFailureEpic,
]
